import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-total-sales',
  templateUrl: './total-sales.component.html',
  styleUrls: ['./total-sales.component.css']
})
export class TotalSalesComponent implements OnInit {
  tableItens!: any;
  totalSales!: string;

  constructor(private router: Router, private api: ApiService) { }

  ngOnInit() {
    this.getTable();
  }

  getTable() {
    this.totalSales = '15.250,00';
    this.tableItens = [
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 15.250,00'},
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 5.250,00'},
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 3.250,00'},
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 12.250,00'},
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 36.250,00'},
      {'Trans.': '1234', cliente: 'Consumidor Teste', 'QT Pçs': '12', 'Valor U.': 'R$ 99,00', 'Valor Venda': 'R$ 1.250,00'}
    ];
  }

  backHome() {
    this.router.navigate(['/home/sale']);
  }
}
